$(document).ready(() => {
    if (window.FormRendererConfig && window.FormRendererConfig.length) {
        const { render } = require('./bootstrap');

        window.FormRendererConfig.forEach(config => {
                const state = {
                    ...config.state,
                    endpoint: config.endpoint,
                    csrfToken: config.csrfToken,
                    formId: config.formId,
                }

                const { store } = render(config.rootId, state);
        })
    }
})